import { React, useState, useEffect } from "react";
import { Modal, TextField, MenuItem, Fade } from "@mui/material";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import GenerarConvenioModal from "./GenerarConvenioModal";
import RegistrarComentarioModal from "./RegistrarComentarioModal";
import request from "../../../../Helpers/API";

const MedioContactoModal = ({ open, onClose, facturasSeleccionadas, idcliente, saldo, moratorios, interespactado, total, responsable }) => {
  const [gestion, setGestion] = useState({
    mediocontacto: "",
    gestion: "",
    objecion: ""
  });

  const [objeciones, setObjeciones] = useState([]);

  // Estado para controlar el modal de Generar Convenios
  const [openGenerarConvenioModal, setOpenGenerarConvenioModal] = useState(false);

  // Maneja la apertura del modal de Generar Convenios
  const handleOpenGenerarConvenioModal = () => {
    onClose(); // Cierra el modal actual
    setOpenGenerarConvenioModal(true); // Abre el modal de Generar Convenios
  };

  // Maneja el cierre del modal de Generar Convenios
  const handleCloseGenerarConvenioModal = () => {
    setOpenGenerarConvenioModal(false);
  };

  const [openRegistrarComentarioModal, setOpenRegistrarComentarioModal] = useState(false);

  // Maneja la apertura del modal de Generar Convenios
  const handleOpenRegistrarComentarioModal = () => {
    onClose(); // Cierra el modal actual
    setOpenRegistrarComentarioModal(true); // Abre el modal de Generar Convenios
  };

  // Maneja el cierre del modal de Generar Convenios
  const handleCloseRegistrarComentarioModal = () => {
    setOpenRegistrarComentarioModal(false);
    onClose();
  };

  const handleRegresarDesdeComentario = () => {
    setOpenRegistrarComentarioModal(false); // Cierra el modal de comentarios
    setTimeout(() => {
      open = true; // Reabre el modal de medio de contacto
    }, 300); // Ajusta el tiempo si es necesario para la animación de cierre del modal
  };

  const handleOpenModal = () => {
    onClose(); // Cierra el modal actual
    if (gestion.gestion === "C") {
      setOpenGenerarConvenioModal(true); // Abre el modal de Generar Convenios
    } else if (gestion.gestion === "M") {
      setOpenRegistrarComentarioModal(true); // Abre el modal de Registrar Comentario
    }
  };

  const [openMedioContactoModal, setOpenMedioContactoModal] = useState(open);

  const handleClose = () => {
    setOpenMedioContactoModal(false);
    onClose();
  };

  useEffect(() => {
    request
      .get(
        `ObjecionesPago/MostrarObjeciones`
      )
      .then((result) => {
        setObjeciones(result);
        return;
      })
      .catch((error) => {
        return;
      });
  }, [open]);

  // console.log(objeciones)

  const capitalizeWords = (text) => {
    return text
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  // console.log(gestion)

  return (
    <>
      {/* Modal para Registrar Contacto */}
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropProps={{
          timeout: 300,
        }}
      // Usamos el componente Fade como la transición del contenido del modal
      >
        <Fade in={open}>
          <div className="plantilla-screen-filtro-container-modal-container">
            <div className="agregar-contacto-modal">
              <div className="agregar-contacto-modal-detalle">
                <div className="agregar-contacto-modal-detalle-formulario">
                  <div className="agregar-contacto-modal-formulario-plantilla">
                    <div
                      className="plantilla-screen-filtro-container"
                      id="mdlFiltros-modal"
                    >
                      <PlantillaScreen
                        titulo={`Registrar Gestión`}
                        className_main={1}
                        className={"plantilla-screen-filtro-container-modal"}
                      >
                        <div className="cerrar-modal-button" onClick={onClose}>
                          X
                        </div>
                        <div
                          className={`agregar-contacto-modal-formulario-plantilla-agregar`}
                        >
                          <div className="agregar-contacto-modal-formulario-plantilla-container scroll-4">
                            <TextField
                              className="input-medio-comunicacion"
                              fullWidth
                              size="small"
                              label="Medio de Contacto"
                              select
                              type="text"
                              value={gestion.mediocontacto}
                              onChange={(e) => {
                                setGestion({
                                  ...gestion,
                                  mediocontacto: e.target.value,
                                });
                              }}
                              sx={{ mt: 2 }}
                            >
                              <MenuItem value={"T"}>Teléfono</MenuItem>
                              <MenuItem value={"W"}>WhatsApp</MenuItem>
                              <MenuItem value={"C"}>Correo</MenuItem>
                              <MenuItem value={"P"}>Pagina Web</MenuItem>
                              <MenuItem value={"V"}>Visita Domiciliaria</MenuItem>
                              <MenuItem value={"E"}>Cliente en Sucursal</MenuItem>
                            </TextField>

                            <TextField
                              className="input-gestion"
                              fullWidth
                              size="small"
                              label="Gestión"
                              select
                              type="text"
                              value={gestion.gestion}
                              onChange={(e) => {
                                setGestion({
                                  ...gestion,
                                  gestion: e.target.value,
                                });
                              }}
                              sx={{ mt: 2 }}
                            >
                              <MenuItem value={"C"}>Realizar Convenio</MenuItem>
                              <MenuItem value={"M"}>Agregar Comentario</MenuItem>
                            </TextField>

                            <TextField
                              className="input-objecion"
                              fullWidth
                              size="small"
                              label="Objeción de Pago"
                              select
                              type="text"
                              value={gestion.objecion}
                              onChange={(e) => {
                                setGestion({
                                  ...gestion,
                                  objecion: e.target.value,
                                });
                              }}
                              sx={{ mt: 2 }}
                            >
                              {objeciones.map((objecion) => (
                                <MenuItem key={objecion.id_Objecion} value={objecion.id_Objecion}>
                                  {capitalizeWords(objecion.descripcion)} 
                                </MenuItem>
                              ))}
                            </TextField>

                          </div>
                          <div className="agregar-contacto-modal-buttons">
                            <button
                              className="agregar-contacto-modal-button-guardar"
                              onClick={handleOpenModal}
                            >
                              Continuar
                            </button>
                          </div>
                        </div>
                      </PlantillaScreen>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </Modal>

      {/* Modal para Generar Convenios */}
      <GenerarConvenioModal
        open={openGenerarConvenioModal}
        onClose={handleCloseGenerarConvenioModal}
        facturasSeleccionadas={facturasSeleccionadas}
        mediocontacto={gestion.mediocontacto}
        gestion={gestion.gestion}
        objecion={gestion.objecion}
        saldo={saldo}
        moratorios={moratorios}
        total={total}
        responsable={responsable}
        idcliente={idcliente}
      />
      <RegistrarComentarioModal
        open={openRegistrarComentarioModal}
        onClose={handleCloseRegistrarComentarioModal}
        onRegresar={handleRegresarDesdeComentario}
        facturasSeleccionadas={facturasSeleccionadas}
        mediocontacto={gestion.mediocontacto}
        gestion={gestion.gestion}
        objecion={gestion.objecion}
        saldo={saldo}
        moratorios={moratorios}
        interespactado={interespactado}
        total={total}
        responsable={responsable}
        idcliente={idcliente}
      />
    </>
  );
};

export default MedioContactoModal;